import React from "react";
import Lottie, { type LottieComponentProps } from "lottie-react";

type LottieAnimationProps = Omit<LottieComponentProps, "animationData"> & {
  animationData: unknown;
};

// Usage:
// import myAnimation from "../assets/lottie/my-animation.json";
// <LottieAnimation animationData={myAnimation} className="h-40 w-40" />
const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  loop = true,
  autoplay = true,
  ...props
}) => {
  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      {...props}
    />
  );
};

export default LottieAnimation;
